import { connect } from 'react-redux';
import { getIsSearchModalShown } from '../../../redux/selectors';
import { openSearchModal, closeSearchModal } from '../../../redux/actions';
const mapStateToProps = (state)=>({
        isSearchModalShown: getIsSearchModalShown(state)
    });
const mapDispatchToProps = {
    openSearchModal,
    closeSearchModal
};
export default connect(mapStateToProps, mapDispatchToProps);
